<template>
  <div
    v-if="isAdmin"
    class="email-right-aside bookmark-tabcontent form theme-form datepicker-responsive h-100"
  >
    <div class="email-body radius-left h-100">
      <div class="h-100">
        <b-overlay
          class="h-100"
          :show="loading"
          rounded="md"
          :style="loading ? 'height:100vh;overflow:hidden;' : ''"
        >
          <div class="card h-100">
            <div class="card-header d-flex customStickyCardHeader">
              <button
                class="close-sidebar-btn"
                type="button"
                @click="onCloseDetail"
              >
                <i class="icon-close f-14" />
              </button>

              <h6 class="card-header-title">
                {{ this.title }}
              </h6>

              <!-- <div>
                <span class="" v-if="form.rid > 0">
                  {{ $t("lbl_EMPBE_CreatedBy") }}: {{ form.createdBy }}<br />
                  {{ $t("lbl_EMPBE_UpdatedBy") }}: {{ form.updatedBy }}
                </span>
              </div> -->

              <div>
                <span class="" v-if="form.rid > 0">
                  {{ $t("lbl_EMPBE_CreatedDate") }}: {{ form.createdDate
                  }}<br />
                  {{ $t("lbl_EMPBE_UpdatedDate") }}: {{ form.updatedDate }}
                </span>
              </div>
            </div>

            <div
              class="card-body pt-0 pb-4 overflow-auto"
              :class="isFormDeleted && 'form-deleted'"
            >
              <div class="row mt-4">
                <ValidationObserver ref="observer">
                  <div class="col-sm-12">
                    <h6>
                      {{ $t("lbl_buyerform_status") }}
                      <span class="text-danger">*</span>
                    </h6>

                    <selection
                      label="status"
                      v-model="form.status"
                      :options="statusOptions"
                      :disabled="isFormDeleted || isNewForm"
                      :clearable="false"
                      :mandatory="
                        this.$t('lbl_buyerform_status') +
                        this.$t('lbl_IsRequire')
                      "
                    />
                  </div>

                  <div
                    class="col-sm-12"
                    v-show="!isNewForm && form.status === 'publish'"
                  >
                    <h6>
                      {{ $t("Lbl_DisplayOrder") }}
                      <span class="text-danger" v-show="isPublishing">
                        {{ " *" }}
                      </span>
                    </h6>

                    <selection
                      label="orderId"
                      v-model="form.orderId"
                      :options="orderOptions"
                      :disabled="isFormDeleted || !isPublishing"
                      :clearable="false"
                      :mandatory="
                        isPublishing
                          ? this.$t('Lbl_DisplayOrder') +
                            this.$t('lbl_IsRequire')
                          : null
                      "
                    />
                  </div>

                  <div class="row px-3">
                    <div class="col-sm-6 m-b-25">
                      <h6>
                        {{ $t("lbl_EMPBE_PublishStart") }}
                        <span class="text-danger" v-show="isPublishing">
                          *
                        </span>
                      </h6>
                      <datePicker_cp
                        class="datePicker"
                        :class="!!publishDateErrorMsg.from && 'date-error'"
                        v-model="form.effectiveFrom"
                        :dateTimeFormat="'yyyy-MM-dd'"
                        data-item="effectiveFrom"
                        @fromChird_selectDate="onChangeEffectiveFrom"
                        :disabled="isFormDeleted"
                        :clearable="!isPublishing"
                        :typeable="true"
                      />
                      <b-form-invalid-feedback
                        :state="!!!publishDateErrorMsg.from"
                      >
                        {{ publishDateErrorMsg.from }}
                      </b-form-invalid-feedback>
                    </div>

                    <div class="col-sm-6 m-b-25">
                      <h6>
                        {{ $t("lbl_EMPBE_PublishEnd") }}
                        <span class="text-danger" v-show="isPublishing">
                          *
                        </span>
                      </h6>

                      <datePicker_cp
                        class="datePicker"
                        :class="!!publishDateErrorMsg.to && 'date-error'"
                        v-model="form.effectiveTo"
                        :dateTimeFormat="'yyyy-MM-dd'"
                        data-item="effectiveTo"
                        @fromChird_selectDate="onChangeEffectiveTo"
                        :disabled="isFormDeleted"
                        :clearable="!isPublishing"
                        :typeable="true"
                      />
                      <b-form-invalid-feedback
                        :state="!!!publishDateErrorMsg.to"
                      >
                        {{ publishDateErrorMsg.to }}
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                </ValidationObserver>

                <div class="col-12 newsDetailTabs">
                  <b-tabs
                    card
                    class="b-light"
                    v-model="currentTab"
                    :no-fade="true"
                  >
                    <div>
                      <b-tab
                        :title-link-attributes="{
                          t_label: 'EMPBE_NewsDetail_tab_Eng',
                        }"
                        :no-fade="true"
                      >
                        <div slot="title">
                          {{ $t("lbl_EMPBE_Eng") }}
                        </div>
                        <div>
                          <ValidationObserver ref="observerEng">
                            <div class="col-12">
                              <h6>
                                {{ this.$t("lbl_EMPBE_Title") }}
                                <span class="text-danger">*</span>
                              </h6>

                              <div
                                class="title-textbox-container d-flex gap-1 m-b-25"
                              >
                                <textbox
                                  class="input-title flex-fill"
                                  ref="title_EN"
                                  name="title_EN"
                                  v-model="form.title_EN"
                                  CharLimit="CheckEnglishChar"
                                  :disabled="isFormDeleted"
                                  :mandatory="
                                    this.$t('lbl_EMPBE_Title') +
                                    this.$t('lbl_IsRequire')
                                  "
                                />
                                <b-button
                                  variant="info"
                                  @click="onAddLineBreak('title_EN')"
                                >
                                  {{ addLineBreakText }}
                                </b-button>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="row">
                                <div class="col-sm-12">
                                  <h6 class="mb-1">
                                    {{ $t("lbl_EMPBE_Picture") }}
                                    <span
                                      class="text-danger"
                                      v-show="isPublishing"
                                    >
                                      {{ " *" }}
                                    </span>
                                  </h6>
                                  <div class="upload-container">
                                    <div class="picture-upload">
                                      <imageUpload
                                        :class="
                                          !isFileRequiredValid['image_EN'] &&
                                          'image-upload-error'
                                        "
                                        componentId="image_EN"
                                        :limit="1"
                                        :limitCropFunction="0"
                                        ref="image_EN"
                                        :aspectRatioselected="1.7667"
                                        :imageArray="image.EN"
                                        :disable="isFormDeleted"
                                        :needImageName="false"
                                      />

                                      <!-- <b-button
                                        v-if="
                                          !isFormDeleted &&
                                          !isNewForm &&
                                          form.imagePath_EN
                                        "
                                        class="m-t-10 m-r-10"
                                        variant="primary"
                                        @click="onCopyToDiffLang('image_EN')"
                                      >
                                        {{
                                          $t(
                                            "lbl_EMPBE_ApplySameImageInDiffLang"
                                          )
                                        }}
                                      </b-button> -->
                                    </div>

                                    <b-form-invalid-feedback
                                      :state="isFileRequiredValid['image_EN']"
                                    >
                                      {{ $t("lbl_EMPBE_PleaseUploadImage") }}
                                    </b-form-invalid-feedback>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 mt-4">
                              <h6>
                                {{ $t("lbl_EMPBE_RedirectURL") }}
                                <span class="text-danger" v-show="isPublishing">
                                  {{ " *" }}
                                </span>
                              </h6>
                              <div>
                                <b-button
                                  class="m-t-5 m-b-10"
                                  :variant="
                                    isRedirectTypeURL
                                      ? 'primary'
                                      : 'outline-primary'
                                  "
                                  @click="onRedirectType('URL')"
                                  :disabled="isFormDeleted"
                                >
                                  {{ "URL" }}
                                </b-button>
                                <b-button
                                  class="m-t-5 m-b-10 m-l-10"
                                  :variant="
                                    isRedirectTypeURL
                                      ? 'outline-secondary'
                                      : 'secondary'
                                  "
                                  @click="onRedirectType('PDF')"
                                  :disabled="isFormDeleted"
                                >
                                  {{ "PDF" }}
                                </b-button>

                                <div class="upload-container">
                                  <div>
                                    <div
                                      v-if="isRedirectTypeURL"
                                      class="d-flex gap-1"
                                    >
                                      <textbox
                                        :style="{
                                          marginBottom: '0 !important',
                                        }"
                                        :inputStyle="{
                                          cursor: 'auto',
                                        }"
                                        class="flex-fill"
                                        name="urlLink_EN"
                                        v-model="form.urlLink_EN"
                                        :disabled="
                                          isFormDeleted || !isRedirectTypeURL
                                        "
                                        :mandatory="
                                          !isPublishing
                                            ? null
                                            : this.$t('lbl_EMPBE_RedirectURL') +
                                              this.$t('lbl_IsRequire')
                                        "
                                      />

                                      <a
                                        target="_blank"
                                        :href="form.urlLink_EN"
                                        class="flex-grow-0 flex-shrink-0 flex-basis-auto"
                                      >
                                        <button
                                          type="button"
                                          class="btn btn-outline-primary"
                                          :disabled="!form.urlLink_EN"
                                        >
                                          <i class="fa fa-link" />
                                          {{ $t("lbl_EMPBE_Check") }}
                                        </button>
                                      </a>
                                    </div>

                                    <div
                                      v-else-if="
                                        !isRedirectTypeURL &&
                                        INIT_DATA.redirectType === 'PDF'
                                      "
                                      class="d-flex gap-1 align-items-center"
                                    >
                                      <div
                                        v-if="form.urlLink_EN"
                                        class="text-primary m-b-10 m-l-10 m-t-5"
                                        style="font-size: 5rem"
                                      >
                                        <a
                                          class="d-flex"
                                          target="_blank"
                                          :href="form.urlLink_EN"
                                        >
                                          <i class="fa fa-file-pdf-o" />
                                        </a>
                                      </div>

                                      <!-- <b-button
                                        v-if="
                                          !isFormDeleted &&
                                          !isNewForm &&
                                          form.urlLink_EN
                                        "
                                        variant="primary"
                                        @click="onCopyToDiffLang('pdf_EN')"
                                      >
                                        {{
                                          $t(
                                            "lbl_EMPBE_ApplySameFileInDiffLang"
                                          )
                                        }}
                                      </b-button> -->
                                    </div>
                                  </div>

                                  <div v-show="!isRedirectTypeURL">
                                    <div class="d-flex gap-1">
                                      <b-form-file
                                        class="flex-fill"
                                        accept="application/pdf"
                                        ref="pdf_EN"
                                        :placeholder="
                                          $t('lbl_EMPBE_InputFile_Placeholder')
                                        "
                                        v-model="pdf.EN"
                                        :browse-text="
                                          $t('lbl_EMPBE_InputFile_BrowseText')
                                        "
                                        :no-drop-placeholder="
                                          $t(
                                            'lbl_EMPBE_InputFile_NoDropPlaceholder'
                                          )
                                        "
                                        :drop-placeholder="
                                          $t(
                                            'lbl_EMPBE_InputFile_DropPlaceholder'
                                          )
                                        "
                                        id="pdf_EN"
                                        :disabled="isFormDeleted"
                                        :state="
                                          isFileRequiredValid['pdf_EN']
                                            ? null
                                            : false
                                        "
                                        @change="
                                          setFileValidState('pdf_EN', true)
                                        "
                                      />

                                      <button
                                        type="button"
                                        class="btn btn-danger flex-grow-0 flex-shrink-0 flex-basis-auto"
                                        @click="pdf.EN = null"
                                        :disabled="isFormDeleted || !pdf.EN"
                                      >
                                        {{ $t("Lbl_Clear") }}
                                      </button>
                                    </div>

                                    <b-form-invalid-feedback
                                      :state="isFileRequiredValid['pdf_EN']"
                                    >
                                      {{ $t("lbl_EMPBE_PleaseUploadFile") }}
                                    </b-form-invalid-feedback>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ValidationObserver>
                        </div>
                      </b-tab>
                      <b-tab
                        :title-link-attributes="{
                          t_label: 'EMPBE_NewsDetail_tab_Trad',
                        }"
                        :no-fade="true"
                      >
                        <div slot="title">
                          {{ $t("lbl_emp2_Trad") }}
                        </div>
                        <div>
                          <ValidationObserver ref="observerTrad">
                            <div class="col-12">
                              <h6>
                                {{ this.$t("lbl_EMPBE_Title") }}
                                <span class="text-danger">*</span>
                              </h6>
                              <div
                                class="title-textbox-container d-flex gap-1 m-b-25"
                              >
                                <textbox
                                  class="input-title flex-fill"
                                  ref="title_TC"
                                  name="title_TC"
                                  v-model="form.title_TC"
                                  :disabled="isFormDeleted"
                                  :mandatory="
                                    this.$t('lbl_EMPBE_Title') +
                                    this.$t('lbl_IsRequire')
                                  "
                                />
                                <b-button
                                  variant="info"
                                  @click="onAddLineBreak('title_TC')"
                                >
                                  {{ addLineBreakText }}
                                </b-button>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="row">
                                <div class="col-sm-12">
                                  <h6 class="mb-1">
                                    {{ $t("lbl_EMPBE_Picture") }}
                                    <span
                                      class="text-danger"
                                      v-show="isPublishing"
                                    >
                                      {{ " *" }}
                                    </span>
                                  </h6>

                                  <div class="upload-container">
                                    <div class="picture-upload">
                                      <imageUpload
                                        :class="
                                          !isFileRequiredValid['image_TC'] &&
                                          'image-upload-error'
                                        "
                                        componentId="image_TC"
                                        :limit="1"
                                        :limitCropFunction="0"
                                        ref="image_TC"
                                        :aspectRatioselected="1.7667"
                                        :imageArray="image.TC"
                                        :disable="isFormDeleted"
                                        :needImageName="false"
                                      />

                                      <!-- <b-button
                                        v-if="
                                          !isFormDeleted &&
                                          !isNewForm &&
                                          form.imagePath_TC
                                        "
                                        class="m-t-10"
                                        variant="primary"
                                        @click="onCopyToDiffLang('image_TC')"
                                      >
                                        {{
                                          $t(
                                            "lbl_EMPBE_ApplySameImageInDiffLang"
                                          )
                                        }}
                                      </b-button> -->
                                    </div>

                                    <b-form-invalid-feedback
                                      :state="isFileRequiredValid['image_TC']"
                                    >
                                      {{ $t("lbl_EMPBE_PleaseUploadImage") }}
                                    </b-form-invalid-feedback>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 mt-4">
                              <h6>
                                {{ $t("lbl_EMPBE_RedirectURL") }}
                                <span class="text-danger" v-show="isPublishing">
                                  {{ " *" }}
                                </span>
                              </h6>
                              <div>
                                <b-button
                                  class="m-t-5 m-b-10"
                                  :variant="
                                    isRedirectTypeURL
                                      ? 'primary'
                                      : 'outline-primary'
                                  "
                                  @click="onRedirectType('URL')"
                                  :disabled="isFormDeleted"
                                >
                                  {{ "URL" }}
                                </b-button>
                                <b-button
                                  class="m-t-5 m-b-10 m-l-10"
                                  :variant="
                                    isRedirectTypeURL
                                      ? 'outline-secondary'
                                      : 'secondary'
                                  "
                                  @click="onRedirectType('PDF')"
                                  :disabled="isFormDeleted"
                                >
                                  {{ "PDF" }}
                                </b-button>

                                <div class="upload-container">
                                  <div>
                                    <div
                                      v-if="isRedirectTypeURL"
                                      class="d-flex gap-1"
                                    >
                                      <textbox
                                        :style="{
                                          marginBottom: '0 !important',
                                        }"
                                        :inputStyle="{
                                          cursor: 'auto',
                                        }"
                                        class="flex-fill"
                                        name="urlLink_TC"
                                        v-model="form.urlLink_TC"
                                        :disabled="isFormDeleted"
                                        :mandatory="
                                          !isPublishing
                                            ? null
                                            : this.$t('lbl_EMPBE_RedirectURL') +
                                              this.$t('lbl_IsRequire')
                                        "
                                      />

                                      <a
                                        target="_blank"
                                        :href="form.urlLink_TC"
                                      >
                                        <button
                                          type="button"
                                          class="btn btn-outline-primary"
                                          :disabled="!form.urlLink_TC"
                                        >
                                          <i class="fa fa-link" />
                                          {{ $t("lbl_EMPBE_Check") }}
                                        </button>
                                      </a>
                                    </div>

                                    <div
                                      v-else-if="
                                        !isRedirectTypeURL &&
                                        INIT_DATA.redirectType === 'PDF'
                                      "
                                      class="d-flex gap-1 align-items-center"
                                    >
                                      <div
                                        v-if="form.urlLink_TC"
                                        class="text-primary m-b-10 m-l-10 m-t-5"
                                        style="font-size: 5rem"
                                      >
                                        <a
                                          class="d-flex"
                                          target="_blank"
                                          :href="form.urlLink_TC"
                                        >
                                          <i class="fa fa-file-pdf-o" />
                                        </a>
                                      </div>

                                      <!-- <b-button
                                        v-if="
                                          !isFormDeleted &&
                                          !isNewForm &&
                                          form.urlLink_TC
                                        "
                                        variant="primary"
                                        @click="onCopyToDiffLang('pdf_TC')"
                                      >
                                        {{
                                          $t(
                                            "lbl_EMPBE_ApplySameFileInDiffLang"
                                          )
                                        }}
                                      </b-button> -->
                                    </div>
                                  </div>

                                  <div v-show="!isRedirectTypeURL">
                                    <div class="d-flex gap-1">
                                      <b-form-file
                                        class="flex-fill"
                                        accept="application/pdf"
                                        ref="pdf_TC"
                                        :placeholder="
                                          $t('lbl_EMPBE_InputFile_Placeholder')
                                        "
                                        v-model="pdf.TC"
                                        :browse-text="
                                          $t('lbl_EMPBE_InputFile_BrowseText')
                                        "
                                        :no-drop-placeholder="
                                          $t(
                                            'lbl_EMPBE_InputFile_NoDropPlaceholder'
                                          )
                                        "
                                        :drop-placeholder="
                                          $t(
                                            'lbl_EMPBE_InputFile_DropPlaceholder'
                                          )
                                        "
                                        id="pdf_TC"
                                        :disabled="isFormDeleted"
                                        :state="
                                          isFileRequiredValid['pdf_TC']
                                            ? null
                                            : false
                                        "
                                        @change="
                                          setFileValidState('pdf_TC', true)
                                        "
                                      />

                                      <button
                                        type="button"
                                        class="btn btn-danger flex-grow-0 flex-shrink-0 flex-basis-auto"
                                        @click="pdf.TC = null"
                                        :disabled="isFormDeleted || !pdf.TC"
                                      >
                                        {{ $t("Lbl_Clear") }}
                                      </button>
                                    </div>

                                    <b-form-invalid-feedback
                                      :state="isFileRequiredValid['pdf_TC']"
                                    >
                                      {{ $t("lbl_EMPBE_PleaseUploadFile") }}
                                    </b-form-invalid-feedback>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ValidationObserver>
                        </div>
                      </b-tab>
                      <b-tab
                        :title-link-attributes="{
                          t_label: 'EMPBE_NewsDetail_tab_Simp',
                        }"
                        :no-fade="true"
                      >
                        <div slot="title">
                          {{ $t("lbl_emp2_Simp") }}
                        </div>
                        <div>
                          <ValidationObserver ref="observerSimp">
                            <div class="col-12">
                              <h6>
                                {{ this.$t("lbl_EMPBE_Title") }}
                                <span class="text-danger"> *</span>
                              </h6>

                              <div
                                class="title-textbox-container d-flex gap-1 m-b-25"
                              >
                                <textbox
                                  class="input-title flex-fill"
                                  ref="title_SC"
                                  name="title_SC"
                                  v-model="form.title_SC"
                                  :disabled="isFormDeleted"
                                  :mandatory="
                                    this.$t('lbl_EMPBE_Title') +
                                    this.$t('lbl_IsRequire')
                                  "
                                />
                                <b-button
                                  variant="info"
                                  @click="onAddLineBreak('title_SC')"
                                >
                                  {{ addLineBreakText }}
                                </b-button>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="row">
                                <div class="col-sm-12">
                                  <h6 class="mb-1">
                                    {{ $t("lbl_EMPBE_Picture") }}
                                    <span
                                      class="text-danger"
                                      v-show="isPublishing"
                                    >
                                      {{ " *" }}
                                    </span>
                                  </h6>

                                  <div class="upload-container">
                                    <div class="picture-upload">
                                      <imageUpload
                                        :class="
                                          !isFileRequiredValid['image_SC'] &&
                                          'image-upload-error'
                                        "
                                        componentId="image_SC"
                                        :limit="1"
                                        :limitCropFunction="0"
                                        ref="image_SC"
                                        :aspectRatioselected="1.7667"
                                        :imageArray="image.SC"
                                        :disable="isFormDeleted"
                                        :needImageName="false"
                                      />

                                      <!-- <b-button
                                        v-if="
                                          !isFormDeleted &&
                                          !isNewForm &&
                                          form.imagePath_SC
                                        "
                                        class="m-t-10"
                                        variant="primary"
                                        @click="onCopyToDiffLang('image_SC')"
                                      >
                                        {{
                                          $t(
                                            "lbl_EMPBE_ApplySameImageInDiffLang"
                                          )
                                        }}
                                      </b-button> -->
                                    </div>

                                    <b-form-invalid-feedback
                                      :state="isFileRequiredValid['image_SC']"
                                    >
                                      {{ $t("lbl_EMPBE_PleaseUploadImage") }}
                                    </b-form-invalid-feedback>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 mt-4">
                              <h6>
                                {{ $t("lbl_EMPBE_RedirectURL") }}
                                <span class="text-danger" v-show="isPublishing">
                                  {{ " *" }}
                                </span>
                              </h6>
                              <div>
                                <b-button
                                  class="m-t-5 m-b-10"
                                  :variant="
                                    isRedirectTypeURL
                                      ? 'primary'
                                      : 'outline-primary'
                                  "
                                  @click="onRedirectType('URL')"
                                  :disabled="isFormDeleted"
                                >
                                  {{ "URL" }}
                                </b-button>
                                <b-button
                                  class="m-t-5 m-b-10 m-l-10"
                                  :variant="
                                    isRedirectTypeURL
                                      ? 'outline-secondary'
                                      : 'secondary'
                                  "
                                  @click="onRedirectType('PDF')"
                                  :disabled="isFormDeleted"
                                >
                                  {{ "PDF" }}
                                </b-button>

                                <div class="upload-container">
                                  <div>
                                    <div
                                      v-if="isRedirectTypeURL"
                                      class="d-flex gap-1"
                                    >
                                      <textbox
                                        v-if="isRedirectTypeURL"
                                        :style="{
                                          marginBottom: '0 !important',
                                        }"
                                        :inputStyle="{
                                          cursor: 'auto',
                                        }"
                                        class="flex-fill"
                                        name="urlLink_SC"
                                        v-model="form.urlLink_SC"
                                        :disabled="isFormDeleted"
                                        :mandatory="
                                          !isPublishing
                                            ? null
                                            : this.$t('lbl_EMPBE_RedirectURL') +
                                              this.$t('lbl_IsRequire')
                                        "
                                      />

                                      <a
                                        v-if="isRedirectTypeURL"
                                        target="_blank"
                                        :href="form.urlLink_SC"
                                      >
                                        <button
                                          type="button"
                                          class="btn btn-outline-primary"
                                          :disabled="!form.urlLink_SC"
                                        >
                                          <i class="fa fa-link" />
                                          {{ $t("lbl_EMPBE_Check") }}
                                        </button>
                                      </a>
                                    </div>

                                    <div
                                      v-else-if="
                                        !isRedirectTypeURL &&
                                        INIT_DATA.redirectType === 'PDF'
                                      "
                                      class="d-flex gap-1 align-items-center"
                                    >
                                      <div
                                        v-if="form.urlLink_SC"
                                        class="text-primary m-b-10 m-l-10 m-t-5"
                                        style="font-size: 5rem"
                                      >
                                        <a
                                          class="d-flex"
                                          target="_blank"
                                          :href="form.urlLink_SC"
                                        >
                                          <i class="fa fa-file-pdf-o" />
                                        </a>
                                      </div>

                                      <!-- <b-button
                                        v-if="
                                          !isFormDeleted &&
                                          !isNewForm &&
                                          form.urlLink_SC
                                        "
                                        variant="primary"
                                        @click="onCopyToDiffLang('pdf_SC')"
                                      >
                                        {{
                                          $t(
                                            "lbl_EMPBE_ApplySameFileInDiffLang"
                                          )
                                        }}
                                      </b-button> -->
                                    </div>
                                  </div>

                                  <div v-show="!isRedirectTypeURL">
                                    <div class="d-flex gap-1">
                                      <b-form-file
                                        class="flex-fill"
                                        accept="application/pdf"
                                        ref="pdf_SC"
                                        :placeholder="
                                          $t('lbl_EMPBE_InputFile_Placeholder')
                                        "
                                        v-model="pdf.SC"
                                        :browse-text="
                                          $t('lbl_EMPBE_InputFile_BrowseText')
                                        "
                                        :no-drop-placeholder="
                                          $t(
                                            'lbl_EMPBE_InputFile_NoDropPlaceholder'
                                          )
                                        "
                                        :drop-placeholder="
                                          $t(
                                            'lbl_EMPBE_InputFile_DropPlaceholder'
                                          )
                                        "
                                        id="pdf_SC"
                                        :disabled="isFormDeleted"
                                        :state="
                                          isFileRequiredValid['pdf_SC']
                                            ? null
                                            : false
                                        "
                                        @change="
                                          setFileValidState('pdf_SC', true)
                                        "
                                      />

                                      <button
                                        type="button"
                                        class="btn btn-danger flex-grow-0 flex-shrink-0 flex-basis-auto"
                                        @click="pdf.SC = null"
                                        :disabled="isFormDeleted || !pdf.SC"
                                      >
                                        {{ $t("Lbl_Clear") }}
                                      </button>
                                    </div>
                                    <b-form-invalid-feedback
                                      :state="isFileRequiredValid['pdf_SC']"
                                    >
                                      {{ $t("lbl_EMPBE_PleaseUploadFile") }}
                                    </b-form-invalid-feedback>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ValidationObserver>
                        </div>
                      </b-tab>
                    </div>
                  </b-tabs>
                </div>
              </div>
            </div>
            <div
              class="card-footer customStickyCardFooter d-flex justify-content-end"
            >
              <b-button-group>
                <b-button
                  v-if="!isFormDeleted && !isNewForm"
                  variant="light"
                  size="lg"
                  @click="onClickDelete"
                >
                  <i class="fa fa-trash-o m-r-5" />{{
                    this.$t("lbl_EMPBE_Delete")
                  }}
                </b-button>

                <b-button
                  v-if="!isFormDeleted && isNewForm"
                  variant="primary"
                  size="lg"
                  @click="onClickSave"
                >
                  <i class="fa fa-save m-r-5" />{{
                    this.$t("lbl_EMPBE_Create")
                  }}
                </b-button>

                <b-button
                  v-if="!isFormDeleted && !isNewForm"
                  variant="success"
                  size="lg"
                  @click="onClickUpdate"
                >
                  <i class="fa fa-save m-r-5" />{{
                    this.$t("lbl_EMPBE_Update")
                  }}
                </b-button>

                <b-button
                  v-if="!isNewForm"
                  variant="primary"
                  size="lg"
                  @click="onClickDuplicate"
                >
                  <i class="fa fa-copy m-r-5" />{{
                    this.$t("lbl_EMPBE_Duplicate")
                  }}
                </b-button>
              </b-button-group>
            </div>
          </div>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
import {
  sourcingTrendService,
  fileUploadService,
  userService,
} from "../../../_services";
import { AlertDialog } from "@/_helpers/AlertDialog";

export default {
  mixins: [AlertDialog],
  data() {
    return {
      dirty: false,
      loading: true,
      currentTab: 0, // default tab (0 == "EN" | 1 == "TC" | 2 == "SC")

      // Form Data for update and display in UI
      form: {
        //   "rid": 1,
        //   "reportType": "Type1",
        //   "title_EN": "Title1",
        //   "title_TC": "Default_Title_TC",
        //   "title_SC": "Default_Title_SC",
        //   "urlLink_EN": "url1",
        //   "urlLink_TC": "Default_UrlLink_TC",
        //   "urlLink_SC": "Default_UrlLink_SC",
        //   "redirectType": "URL",
        //   "pdfPath": "path1.pdf",
        //   "imagePath_EN": "image1.jpg",
        //   "imagePath_TC": "Default_ImagePath_TC",
        //   "imagePath_SC": "Default_ImagePath_SC",
        //   "tlabel": "Label1",
        //   "orderId": 1,
        //   "status": 1,
        //   "effectiveFrom": "2022-01-01 00:00:00",
        //   "effectiveTo": "2022-01-31 00:00:00",
        //   "createdDate": "2022-01-01 00:00:00",
        //   "createdBy": "Admin1",
        //   "updatedDate": "2022-01-01 00:00:00",
        //   "updatedBy": "Admin1"
      },

      // Initial form data from DB stored for checking and other manipulation
      INIT_DATA: {
        status: "", // "unpublish" | "publish" | "deleted"
        redirectType: "", // "URL" | "PDF"
        urlLink_EN: "",
        urlLink_TC: "",
        urlLink_SC: "",
      },

      // image data
      image: {
        EN: [],
        TC: [],
        SC: [],
      },

      // pdf data
      pdf: {
        EN: null, // Data Type: File
        TC: null, // Data Type: File
        SC: null, // Data Type: File
      },

      statusOptions: [],
      orderOptions: [],

      // To show the file required message for each file
      isFileRequiredValid: {
        image_EN: true,
        image_TC: true,
        image_SC: true,
        pdf_EN: true,
        pdf_TC: true,
        pdf_SC: true,
      },

      // To show the date invalidation message
      publishDateErrorMsg: {
        from: "",
        to: "",
      },
    };
  },

  computed: {
    // ...mapGetters({
    //   getPermissionJsonByUser: "responsePermission/getPermissionJsonByUser",
    // }),
    user() {
      return this.$store.state.authentication.user;
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
    isAdmin() {
      return this.user.userType == "ADMIN";
    },
    istest() {
      console.log("this.$route.params.istest:" + this.$route.query["istest"]);
      if (this.$route.query["istest"] == "true") {
        return true;
      }

      return false;
    },
    title() {
      const paramType = this.$route.params.type;

      return paramType === "SourcingTrend"
        ? this.$t("lbl_EMPBE_SourcingTrend") + ` - ${this.$route.params.id}`
        : paramType === "MarketAnalysis"
        ? this.$t("lbl_EMPBE_MarketAnalysis") + ` - ${this.$route.params.id}`
        : ""; // Wrong type
    },
    isFormDeleted() {
      return this.form.status === "deleted"; // 0: Deleted status
    },
    isNewForm() {
      return this.form.rid === 0; // Newly created form
    },
    isRedirectTypeURL() {
      return this.form.redirectType === "URL";
    },
    isPublishing() {
      return this.form.status === "publish"; // 2: Publish status
    },
    addLineBreakText() {
      return this.langid === "1252"
        ? "Add Line Break"
        : this.langid === "950"
        ? "新增換行"
        : this.langid === "936"
        ? "新增换行"
        : "";
    },
  },

  watch: {
    "$route.params.id": function () {
      this.refresh();
    },

    form: {
      handler() {
        this.dirty = true;
      },
      deep: true,
    },

    "form.status": function (newStatus, oldStatus) {
      if (newStatus === "publish" && oldStatus === "unpublish") {
        // Publish -> Unpublish
        this.form.orderId = 1;
      }

      if (newStatus === "unpublish" && oldStatus === "publish") {
        this.initFormValidation();
      }
    },

    image: {
      handler(image) {
        if (image.EN?.length > 0) this.isFileRequiredValid.image_EN = true;

        if (image.TC?.length > 0) this.isFileRequiredValid.image_TC = true;

        if (image.SC?.length > 0) this.isFileRequiredValid.image_SC = true;
      },
      deep: true,
      immediate: false,
    },
  },

  created() {
    this.initTabIndex();
    this.refresh();
  },

  methods: {
    onAddLineBreak(formKey) {
      this.form[formKey] = this.form[formKey] + "<br>";
      this.$refs[formKey].focusInput();
    },

    async onCloseDetail() {
      if (!this.dirty) {
        this.reloadGrid();
        this.$router.push("/sourcingTrendAndMarketAnalysis");

        return;
      }

      const result = await this.showLeavePage();
      if (result.isConfirmed) {
        this.reloadGrid();
        this.$router.push("/sourcingTrendAndMarketAnalysis");
      }
    },

    /**
     * Updates the redirect type in the form data.
     *
     * @param {"URL" | "PDF"} type - The new redirect type to set.
     */
    onRedirectType(type) {
      if (type === this.INIT_DATA.redirectType) {
        this.form.urlLink_EN = this.INIT_DATA.urlLink_EN;
        this.form.urlLink_TC = this.INIT_DATA.urlLink_TC;
        this.form.urlLink_SC = this.INIT_DATA.urlLink_SC;
      } else {
        this.form.urlLink_EN = "";
        this.form.urlLink_TC = "";
        this.form.urlLink_SC = "";
      }

      // Reset the validation
      this.isFileRequiredValid = {
        ...this.isFileRequiredValid,
        pdf_EN: true,
        pdf_TC: true,
        pdf_SC: true,
      };

      this.form.redirectType = type;
    },

    onChangeEffectiveFrom(newDate) {
      this.form.effectiveFrom = newDate;
      const effectiveTo = this.form.effectiveTo;

      // To validate the publish date and assign the publish date error message
      const isValid = this.isPublishDatePeriodValid(newDate, effectiveTo);

      if (!isValid) {
        return;
      }

      this.publishDateErrorMsg = {
        from: "",
        to: "",
      };
    },

    onChangeEffectiveTo(newDate) {
      this.form.effectiveTo = newDate;
      const effectiveFrom = this.form.effectiveFrom;

      const isValid = this.isPublishDatePeriodValid(effectiveFrom, newDate);

      if (!isValid) {
        return;
      }

      this.publishDateErrorMsg = {
        from: "",
        to: "",
      };
    },

    onClickSave() {
      const that = this;

      that.validateForm().then((isValid) => {
        if (!isValid) return;

        //Show Alert after validation
        that
          .$swal({
            text: this.$t("lbl_EMPBE_ConfirmToSave"),
            showCancelButton: true,
            confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
            cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
          })
          .then(async (res) => {
            if (!res.isConfirmed) return;

            this.save();
          });
      });
    },

    async save() {
      const that = this;
      that.loading = true;

      const { isSuccessful: isUploadSuccessful, ...fileParams } =
        await that.upload();

      if (!isUploadSuccessful) {
        that.loading = false;
        return;
      }

      const params = that.getParams(true);

      const paramsWithFile = { ...params, ...fileParams };

      console.log("paramsWithFile: ", paramsWithFile);

      sourcingTrendService.AddNewContent(paramsWithFile).then((res) => {
        const isSuccessful = res.isSuccessful;
        const message = that.$t(
          isSuccessful ? "lbl_EMPBE_SaveSuccess" : "lbl_EMPBE_SaveFailed"
        );
        that.alertMsg(message);

        if (isSuccessful) {
          that.$router.push({
            name: that.$router.currentRoute.name,
            params: { id: res.data.rid, type: that.$route.params.type },
            replace: true,
          });
        }
      });
    },

    onClickUpdate() {
      const that = this;

      that.validateForm().then((isValid) => {
        if (!isValid) return;

        //Show Alert after validation
        that
          .$swal({
            text: this.$t("lbl_EMPBE_ConfirmToSave"),
            showCancelButton: true,
            confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
            cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
          })
          .then(async (res) => {
            if (!res.isConfirmed) return;

            this.update();
          });
      });
    },

    async update() {
      const that = this;
      that.loading = true;

      const { isSuccessful: isUploadSuccessful, ...fileParams } =
        await that.upload();

      if (!isUploadSuccessful) {
        that.loading = false;
        return;
      }

      const params = that.getParams(false);

      const paramsWithFile = { ...params, ...fileParams };

      console.log("paramsWithFile: ", paramsWithFile);

      sourcingTrendService.UpdateContent(paramsWithFile).then((res) => {
        const isSuccessful = res.isSuccessful;
        const message = that.$t(
          isSuccessful ? "lbl_EMPBE_UpdateSuccess" : "lbl_EMPBE_UpdateFailed"
        );
        that.alertMsg(message);

        if (isSuccessful) {
          that.refresh();
        }
      });
    },

    onClickDuplicate() {
      this.$swal({
        text: this.$t("lbl_EMPBE_ConfirmToDuplicate"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then(async (res) => {
        if (!res.isConfirmed) return;

        this.duplicate();
      });
    },

    duplicate() {
      const that = this;
      const RID = that.form.rid;

      sourcingTrendService.DuplicateContentById(RID).then((res) => {
        if (!res.isSuccessful) {
          const message = that.$t("lbl_EMPBE_DuplicateFailed");
          that.alertMsg(message);

          return;
        }

        const newRID = res.data.rid;

        that
          .$swal({
            text: that.$t("lbl_EMPBE_DuplicateSuccess"),
            showCancelButton: true,
            confirmButtonText: this.$t("lbl_EMPBE_GoToCopiedItem"),
            cancelButtonText: this.$t("lbl_confirm"),
          })
          .then(async (res) => {
            if (!res.isConfirmed) {
              that.refresh();
              return;
            }

            that.$router.push({
              name: that.$router.currentRoute.name,
              params: { id: newRID, type: that.$route.params.type },
              replace: true,
            });
          });
      });
    },

    onClickDelete() {
      this.$swal({
        text: this.$t("lbl_EMPBE_SureToDelete"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then((res) => {
        if (!res.isConfirmed) return;

        this.delete();
      });
    },

    delete() {
      const that = this;
      const RID = that.form.rid;

      sourcingTrendService.DeleteContentById(RID).then((res) => {
        const isSuccessful = res.isSuccessful;
        const message = that.$t(
          isSuccessful ? "lbl_EMPBE_DeleteSuccess" : "lbl_EMPBE_DeleteFailed"
        );

        that.alertMsg(message);

        if (isSuccessful) {
          that.refresh();
        }
      });
    },

    /**
     * Uploads files to the server and returns an object containing the updated file information.
     *
     * @return {Promise<{isSuccessful: false} | {isSuccessful: true; ["ImagePath_EN" | "ImagePath_TC" | "ImagePath_SC" | "UrlLink_EN" | "UrlLink_TC" | "UrlLink_SC"]: string}>}
     * An object containing the updated file information. The object has the following structure:
     * {
     *   isSuccessful: true,
     *   [key]: string // key is the mapped column key, and the value is the CDN link of the uploaded file
     * }
     * If the upload fails, the object will have the following structure:
     * {
     *   isSuccessful: false
     * }
     *
     */
    async upload() {
      const response = {
        isSuccessful: false,
      };

      const filesRequiredToUpload = this.filesRequiredToUpload();

      // return null if no files are required to be uploaded
      if (!filesRequiredToUpload.length)
        return {
          isSuccessful: true,
        };

      filesRequiredToUpload.forEach((componentRefName) => {
        this.appendUploadQuery(componentRefName);
      });

      // Upload file to OSS
      return await fileUploadService
        .UploadToServer(this)
        .then((res) => {
          if (!res || !res.length) {
            const message = this.$t("lbl_EMPBE_UploadFailed");
            this.alertMsg(message);
          }

          if (res.statusCode == 801 || !res || !res.length) {
            return response; // return null image
          }

          const fileUpdateInfo = res.reduce((info, dataItem) => {
            const componentRefName = dataItem.refName;
            const key = this.mapColumnKey(componentRefName);
            const cdnLink = dataItem.array[0].cdnLnk;

            return {
              ...info,
              [key]: cdnLink,
            };
          }, {});

          return {
            isSuccessful: true,
            ...fileUpdateInfo,
          };
        })
        .catch((err) => {
          const message = this.$t("lbl_EMPBE_UploadFailed");
          this.alertMsg(message);

          console.log("fileUploadService Error: ", err);
          return response;
        });
    },

    /**
     * Returns an array of component ref names that are required to be uploaded.
     *
     * @return {Array<"image_EN" | "image_TC" | "image_SC" | "pdf_EN" | "pdf_TC" | "pdf_SC">} An array containing component ref names that are required to be uploaded.
     */
    filesRequiredToUpload() {
      const res = [];

      ["EN", "TC", "SC"].forEach((locale) => {
        if (this.pdf[locale]) {
          res.push(`pdf_${locale}`);
        }

        if (
          this.image[locale] &&
          this.image[locale].length > 0 &&
          this.image[locale][0].modified
        ) {
          res.push(`image_${locale}`);
        }
      });

      return res;
    },

    appendUploadQuery(refName) {
      const fileType = refName.split("_")[0];

      if (fileType === "image") {
        // imageUpload component
        this.$refs[refName].AppendUploadQuery();
      }

      if (fileType === "pdf") {
        // bootstrap file component
        const Src = this.$refs[refName].files[0];

        if (Src) {
          fileUploadService.AppendQuery(refName, "PDF", [
            {
              Src,
              modified: true,
              cdnLnk: "",
              FileName: Src.name,
            },
          ]);
        }
      }
    },

    /**
     * Updates the file path for a given ID, column key, and file path.
     *
     * @param {Object} params - The params object.
     * @param {string} params.rid - The ID.
     * @param {string} params.columnKey - The column key in DB table.
     * @param {string} params.filePath - The file path.
     * @return {Promise<Object|null>} A promise that resolves to the updated data if successful, or null if not.
     */
    async updateFilePath({ rid, columnKey, filePath }) {
      return await sourcingTrendService
        .UpdateFilePath({
          rid,
          filePath,
          columnKey,
        })
        .then((res) => {
          if (res.isSuccessful) {
            return res.data;
          }
        });
    },

    onCopyToDiffLang(refName) {
      const that = this;

      that
        .$swal({
          text: this.$t("lbl_EMPBE_ConfirmToApplySameImageInDiffLang"),
          showCancelButton: true,
          confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
          cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
        })
        .then(async (res) => {
          if (!res.isConfirmed) return;

          const links = await this.copyToDiffLang(refName);

          if (!links || !links.length) return;

          const message = that.$t("lbl_EMPBE_SaveSuccess");
          that.alertMsg(message);

          that.refresh();
        });
    },

    async copyToDiffLang(refName) {
      const rid = this.form.rid;
      const splittedRefName = refName.split("_");
      const dataKey = splittedRefName[0]; // "image" | "pdf"
      const localeKey = splittedRefName[1]; // "EN" | "TC" | "SC"
      const formKey = this.mapColumnKey(refName, false);
      const filePath = this.form[formKey];

      const promises = ["EN", "TC", "SC"]
        .filter((lang) => lang !== localeKey) // Filter out the current locale to find out the other locales
        .map((lang) => {
          // For loop other locales
          const refNameKey = `${dataKey}_${lang}`;
          const columnKey = this.mapColumnKey(refNameKey);

          return this.updateFilePath({
            rid,
            filePath,
            columnKey,
          });
        });

      return await Promise.all(promises);
    },

    async validateForm() {
      const that = this;
      const isPublishing = that.isPublishing;
      const effectiveFrom = that.form.effectiveFrom;
      const effectiveTo = that.form.effectiveTo;

      const valid_MainForm = await that.$refs.observer
        .validate()
        .then((res) => {
          return res;
        });

      const isPublishDateValid = that.validatePublishDate(
        effectiveFrom,
        effectiveTo,
        isPublishing
      );

      const observerLocaleMap = {
        EN: "observerEng",
        TC: "observerTrad",
        SC: "observerSimp",
      };

      const isLocaleFormValid = {
        EN: true,
        TC: true,
        SC: true,
      };

      // Check each locale form input (title, image, redirect link)
      for (const locale of ["EN", "TC", "SC"]) {
        const localeObserverKey = observerLocaleMap[locale];
        const isLocaleObserverValid = await that.$refs[
          localeObserverKey
        ].validate();

        if (!isLocaleObserverValid) {
          // Current locale form input (title || redirect URL) is not valid
          isLocaleFormValid[locale] = false;
        }

        if (!isPublishing) continue; // Image and redirect link is not required if not publishing, so below checking is skipped

        const imageRefName = `image_${locale}`;
        const isImageAdded = that.image[locale]?.length > 0;

        // If image is not added, show error msg and set the validity state to false
        if (!isImageAdded) {
          that.setFileValidState(imageRefName, false);
          isLocaleFormValid[locale] = false;
        }

        if (that.isRedirectTypeURL) continue; // Redirect PDF link is not required if redirect type is URL, so below checking is skipped

        const pdfRefName = `pdf_${locale}`;
        const pdfFormKey = that.mapColumnKey(pdfRefName, false);
        const isPdfAdded = that.form[pdfFormKey] || !!that.pdf[locale];

        // If pdf is not added, show error msg and set the validity state to false
        if (!isPdfAdded) {
          that.setFileValidState(pdfRefName, false);
          isLocaleFormValid[locale] = false;
        }
      }

      // Direct to the tab where the form is not valid
      if (
        !isLocaleFormValid.EN ||
        !isLocaleFormValid.TC ||
        !isLocaleFormValid.SC
      ) {
        that.currentTab = !isLocaleFormValid.EN
          ? 0
          : !isLocaleFormValid.TC
          ? 1
          : 2;
      }

      // Return true if all locale forms are valid
      return (
        valid_MainForm &&
        isPublishDateValid &&
        isLocaleFormValid.EN === true &&
        isLocaleFormValid.TC === true &&
        isLocaleFormValid.SC === true
      );
    },

    /**
     * Validates the publish date and assign new value for publishDateErrorMsg if it is invalid.
     *
     * @param {string | Date | null} effectiveFrom - The effective from date.
     * @param {string | Date | null} effectiveTo - The effective to date.
     * @param {boolean} isPublishing - Indicates if the date is being published.
     * @return {boolean} Returns true if the date period is valid, false otherwise.
     */
    validatePublishDate(effectiveFrom, effectiveTo, isPublishing) {
      const isDatePeriodValid = this.isPublishDatePeriodValid(
        effectiveFrom,
        effectiveTo
      );

      if (!isDatePeriodValid) {
        return false;
      }

      if (isPublishing) {
        const startRequiredMsg =
          this.$t("lbl_EMPBE_PublishStart") + this.$t("lbl_IsRequire");
        const endRequiredMsg =
          this.$t("lbl_EMPBE_PublishEnd") + this.$t("lbl_IsRequire");

        this.publishDateErrorMsg = {
          from: !!effectiveFrom ? "" : startRequiredMsg,
          to: !!effectiveTo ? "" : endRequiredMsg,
        };

        return !!effectiveFrom && !!effectiveTo;
      }

      this.publishDateErrorMsg = {
        from: "",
        to: "",
      };

      return true;
    },

    isPublishDatePeriodValid(effectiveFrom, effectiveTo) {
      // If date period is invalid
      if (
        effectiveFrom &&
        effectiveTo &&
        !this.isDatePeriodValid(effectiveFrom, effectiveTo)
      ) {
        const warningMsg = this.$t("lbl_EMPBE_DatePeriodInvalid");
        this.publishDateErrorMsg = {
          from: warningMsg,
          to: warningMsg,
        };

        return false;
      }

      return true;
    },

    /**
     * Sets the validity state of a file input reference.
     *
     * @param {"image_EN" | "image_TC" | "image_SC" | "pdf_EN" | "pdf_TC" | "pdf_SC"} refName - The key of isFileRequiredValid. ("image_EN" | "image_TC" | "image_SC" | "pdf_EN" | "pdf_TC" | "pdf_SC")
     * @param {boolean} isValid - The validity state of the file input.
     */
    setFileValidState(refName, isValid) {
      this.isFileRequiredValid[refName] = isValid;
    },

    /**
     * Maps a reference name to a column key in the database table or a form key in the UI.
     *
     * @param {"image_EN" | "image_TC" | "image_SC" | "pdf_EN" | "pdf_TC" | "pdf_SC"} refName - The reference name to be mapped. ("image_EN" | "image_TC" | "image_SC" | "pdf_EN" | "pdf_TC" | "pdf_SC")
     * @param {boolean} [isDBKey=true] - Indicates whether to return the column key in the database table or the form key in the UI. Default is true.
     * @return {"ImagePath_EN" | "ImagePath_TC" | "ImagePath_SC" | "UrlLink_EN" | "UrlLink_TC" | "UrlLink_SC" | "imagePath_EN" | "imagePath_TC" | "imagePath_SC" | "urlLink_EN" | "urlLink_TC" | "urlLink_SC"} The mapped column key or form key.
     */
    mapColumnKey(refName, isDBKey = true) {
      // Value is the columnKey in DB table case sensitive
      // The column key in DB is PascalCase (First letter is uppercase)
      // The form key in UI is camelCase (First letter is lowercase)
      // As the API response comeback change the db column key from PascalCase to camelCase, but don't ask me why it got changed
      return {
        image_EN: isDBKey ? "ImagePath_EN" : "imagePath_EN",
        image_TC: isDBKey ? "ImagePath_TC" : "imagePath_TC",
        image_SC: isDBKey ? "ImagePath_SC" : "imagePath_SC",
        pdf_EN: isDBKey ? "UrlLink_EN" : "urlLink_EN",
        pdf_TC: isDBKey ? "UrlLink_TC" : "urlLink_TC",
        pdf_SC: isDBKey ? "UrlLink_SC" : "urlLink_SC",
      }[refName];
    },

    refresh() {
      this.initFormValidation();
      this.initData();
    },

    refreshAfterSave() {
      this.reloadGrid();
      this.refresh();
    },

    reloadGrid() {
      this.$parent.$parent.$refs.STMAGrid.getData();
    },

    initData() {
      const that = this;

      const requestRIDStr = this.$route.params.id; // string
      const requestRID = parseInt(requestRIDStr);

      if (requestRID > 0) {
        that.loading = true;

        sourcingTrendService
          .LoadContentsById(requestRID)
          .then((res) => {
            if (res.isSuccessful) {
              const currentForm = that.form;
              that.form = {
                ...currentForm,
                ...res.data,
              };
              that.INIT_DATA = {
                status: res.data.status,
                redirectType: res.data.redirectType,
                urlLink_EN: res.data.urlLink_EN,
                urlLink_TC: res.data.urlLink_TC,
                urlLink_SC: res.data.urlLink_SC,
              };

              const status = res.data.status;
              const reportType = res.data.reportType;
              that.initStatusOptions(status);
              that.initOrderOptions(reportType, status);
              that.initPDFData();

              ["EN", "TC", "SC"].forEach((locale) => {
                const imagePathKey = `imagePath_${locale}`;
                const imagePath = res.data[imagePathKey];

                that.image[locale] = imagePath
                  ? [
                      that.mapFileUploadData(
                        res.data[imagePathKey],
                        imagePathKey
                      ),
                    ]
                  : [];
              });
            }
          })
          .finally(() => {
            that.dirty = false;
            that.loading = false;
          });
      }

      if (requestRID === 0) {
        that.loading = true;

        const paramType = that.$route.params.type;

        const type =
          paramType === "SourcingTrend"
            ? "Sourcing_Trend"
            : paramType === "MarketAnalysis"
            ? "Market_Analysis"
            : null; // Wrong type

        // Default Data
        const defaultStatus = "unpublish"; // 1: "unpublish"
        const defaultRedirectType = "URL";
        const defaultForm = {
          rid: 0,
          reportType: type,
          title_EN: "",
          title_TC: "",
          title_SC: "",
          urlLink_EN: null,
          urlLink_TC: null,
          urlLink_SC: null,
          pdfPath: null,
          imagePath_EN: null,
          imagePath_TC: null,
          imagePath_SC: null,
          redirectType: defaultRedirectType,
          orderId: null,
          status: defaultStatus,
          tlabel: null,
          effectiveFrom: this.formatDateString(new Date()),
          effectiveTo: this.formatDateString(new Date("2099-12-31")),
          createdDate: null,
          createdBy: null,
          updatedDate: null,
          updatedBy: null,
        };

        that.INIT_DATA.status = defaultStatus;
        that.INIT_DATA.redirectType = defaultRedirectType;
        that.form = {
          ...that.form,
          ...defaultForm,
        };

        that.initStatusOptions(defaultStatus);
        that.dirty = false;
        that.loading = false;
      }
    },

    initTabIndex() {
      this.currentTab =
        this.langid === "1252"
          ? 0
          : this.langid === "950"
          ? 1
          : this.langid === "936"
          ? 2
          : 0;
    },

    initStatusOptions(status) {
      const deleteOption =
        status === "deleted"
          ? [{ id: "deleted", label: this.$t("lbl_EMPBE_Deleted") }]
          : [];

      this.statusOptions = [
        { id: "unpublish", label: this.$t("lbl_EMPBE_Unpublish") },
        { id: "publish", label: this.$t("lbl_EMPBE_Publish") },
        ...deleteOption,
      ];
    },

    initOrderOptions(reportType, initStatus) {
      sourcingTrendService
        .GetOrderOptionsByReportType(reportType)
        .then((res) => {
          if (res.isSuccessful) {
            const isInitUnpublish = initStatus === "unpublish";
            const orderOptionsLength = res.data.length;
            const lastOrderId = res.data[orderOptionsLength - 1]?.id ?? 0;
            const newId = lastOrderId + 1;
            this.orderOptions = isInitUnpublish
              ? [...res.data, { id: newId, label: `${newId}` }]
              : res.data;
          }
        });
    },

    initPDFData() {
      this.pdf = {
        EN: null,
        TC: null,
        SC: null,
      };
    },

    initFormValidation() {
      this.isFileRequiredValid = {
        // To show the file required message for each file
        image_EN: true,
        image_TC: true,
        image_SC: true,
        pdf_EN: true,
        pdf_TC: true,
        pdf_SC: true,
      };

      this.publishDateErrorMsg = {
        from: "",
        to: "",
      };
    },

    mapFileUploadData(cdnLnk, componentRefName) {
      return {
        imageSrc: cdnLnk,
        imageName: cdnLnk,
        OrderId: 1,
        FileName: cdnLnk,
        cdnLnk: cdnLnk,
        imageId: componentRefName,
        modified: false,
      };
    },

    getParams(isNewForm) {
      const form = this.form;

      const effectiveFrom = form.effectiveFrom
        ? this.formatDateString(form.effectiveFrom)
        : null;
      const effectiveTo = form.effectiveTo
        ? this.formatDateString(form.effectiveTo)
        : null;

      const newFormParams = {
        reportType: form.reportType,
        title_EN: form.title_EN,
        title_TC: form.title_TC,
        title_SC: form.title_SC,
        status: form.status,
        effectiveFrom,
        effectiveTo,
        urlLink_EN: form.urlLink_EN,
        urlLink_TC: form.urlLink_TC,
        urlLink_SC: form.urlLink_SC,
        redirectType: form.redirectType,
        imagePath_EN: form.imagePath_EN,
        imagePath_TC: form.imagePath_TC,
        imagePath_SC: form.imagePath_SC,
      };

      if (isNewForm) return newFormParams;

      const wholeFormParams = {
        ...newFormParams,
        rid: form.rid,
        orderId: form.orderId,
      };

      return wholeFormParams;
    },

    alertMsg(message) {
      this.$swal({
        text: message,
        showCancelButton: false,
      });
    },

    /**
     * Formats a given date string into a standardized format.
     *
     * @param {string | Date} dateString - The date string or date to be formatted.
     * @return {string} The formatted date string in the format "YYYY-MM-DD".
     */
    formatDateString: function (dateString) {
      try {
        const date = new Date(dateString);
        const mm = date.getMonth() + 1; // getMonth() is zero-based
        const dd = date.getDate();

        return [
          date.getFullYear() + "-",
          (mm > 9 ? "" : "0") + mm + "-",
          (dd > 9 ? "" : "0") + dd,
        ].join("");
      } catch (ex) {
        return "ERROR";
      }
    },

    /**
     * Checks if the given date period is valid.
     *
     * @param {string | Date} fromDateString - The start date of the period in string format or Date.
     * @param {string | Date} toDateString - The end date of the period in string format or Date.
     * @return {boolean} Returns true if the date period is valid, false otherwise.
     */
    isDatePeriodValid: function (fromDateString, toDateString) {
      const from = this.formatDateString(fromDateString);
      const to = this.formatDateString(toDateString);

      return new Date(from) <= new Date(to);
    },
  },
};
</script>

<style lang="scss">
@import "../style/detail";
</style>
